import React from "react"
import { Box } from "rebass"

const HashtagBox = () => <Box variant="hashtag">#uncannyvalley</Box>

export default HashtagBox
